import { createReducer } from '@reduxjs/toolkit';
import { PAYEVER } from '@yme/components/CheckoutForm/constants';
import { BillingOptions } from '../ShippingDetailsForm/BillingAddress/constants';
import { actions } from './actions';
import { initialLabels } from './initialData';
export const initialState = {
    labels: initialLabels,
    asGuestEmail: '',
    orderReviewModel: {
        labels: {
            checkout_orderReviewDeliveryAddress_header: ' ',
            checkout_orderReviewDetails_description: ' ',
            checkout_orderReviewDetails_header: ' ',
            checkout_orderReviewDisclaimer_text: ' ',
            checkout_orderReviewEditDetails_link: ' ',
            checkout_orderReviewPersonalDetails_header: ' ',
            checkout_orderReviewTableAddress_label: ' ',
            checkout_orderReviewTableBillingAddress_label: ' ',
            checkout_orderReviewTableContact_label: ' ',
            checkout_orderReviewTableEmail_label: ' ',
            checkout_orderReviewTablePhone_label: ' ',
            checkout_orderReviewTermsAndConditionsCheckbox_text: ' ',
            checkout_orderReviewTermsAndConditions_link: ' ',
        },
        termsAndConditionsLink: null,
    },
    salutations: {},
    loqateKey: '',
    googleKey: '',
    currentStepNumber: 0,
    currentFormName: ' ',
    personalDetailsData: {
        data: {
            firstName: '',
            lastName: '',
            salutation: '',
            email: '',
            phoneNumber: '',
        },
        isPersonalDetailsFieldErrors: false,
    },
    isCreateAcc: false,
    isShippingDetailsContinue: false,
    isPickUpAtDealerDisabled: false,
    shippingDetailsData: {
        data: {
            city: '',
            address: '',
            postalCode: '',
            state: '',
            country: '',
        },
        isShippingDetailsFieldErrors: false,
    },
    billingAddressData: {
        data: {
            city: '',
            address: '',
            postalCode: '',
            state: '',
            country: '',
        },
        billingOption: BillingOptions.SAME_AS_SHIPPING_ADDRESS,
        isBillingAddressFieldErrors: false,
        sameAsShippingAddress: false,
        billingCountries: [],
        billingStates: null,
    },
    dealerData: {
        dealerList: [],
        activePreferDealerId: null,
    },
    orderReviewData: {
        orderId: '',
        status: '',
        isLoading: false,
        errorResponse: {},
        santanderPaymentLink: '',
        orderNumber: undefined,
    },
    payment: {
        config: {
            method: '',
        },
        data: {
            sessionData: '',
            amount: {
                value: 0,
                currency: '',
            },
            shopperLocale: '',
        },
        session: {
            sessionData: '',
            amount: {
                value: 0,
                currency: '',
            },
            shopperLocale: '',
        },
        error: undefined,
    },
    paymentProvider: 'adyen',
    modal: {
        state: '',
        title: '',
        description: '',
        primaryButtonContent: '',
        secondaryButtonContent: '',
    },
    shippingDetailsEmailError: '',
    dealersTools: {
        dealersToolsEnabled: false,
        labels: {},
        services: [],
        hyperdriveEndpoints: {
            hashedCartIdEndpoint: '',
            cartIdByHashEndpoint: '',
        },
        privacyPolicyPageLink: null,
    },
    addressConfig: {
        internalCountries: [],
        internalCountryFieldEnabled: false,
        postalCodeConfigModel: {
            alphanumericCodeExclusions: [],
            numericCodeExclusions: [],
            postalCodeRegexp: '',
        },
        stateFieldEnabled: false,
        states: [],
    },
    isCheckoutLogin: false,
    payeverConfigModel: {
        isIframeDisabled: false,
        isOpenInNewTab: false,
        maxPrice: 0,
        minPrice: 0,
        paymentProvider: PAYEVER,
    },
    isBillingDealersSwapped: false,
    isPostalCodeInExclusionList: false,
};
function swapBillingAndDealers(state, { payload }) {
    return {
        ...state,
        isBillingDealersSwapped: payload,
    };
}
function setPostalCodeInExclusionList(state, { payload }) {
    return {
        ...state,
        isPostalCodeInExclusionList: payload,
    };
}
function setCheckoutLabels(state, { payload }) {
    return {
        ...state,
        labels: payload,
    };
}
function setCurrentStepNumber(state, { payload }) {
    return {
        ...state,
        currentStepNumber: payload,
    };
}
function setAsGuestEmail(state, { payload }) {
    return {
        ...state,
        asGuestEmail: payload,
    };
}
function setCurrentFormName(state, { payload }) {
    return {
        ...state,
        currentFormName: payload,
    };
}
function setSalutations(state, { payload }) {
    return {
        ...state,
        salutations: payload,
    };
}
function setPickUpAtDealerDisabled(state, { payload }) {
    return {
        ...state,
        isPickUpAtDealerDisabled: payload,
    };
}
function setPersonalDetailsData(state, { payload }) {
    return {
        ...state,
        personalDetailsData: {
            ...state.personalDetailsData,
            data: payload,
        },
    };
}
function setPersonalDetailsErrorsFieldError(state, { payload }) {
    return {
        ...state,
        personalDetailsData: {
            ...state.personalDetailsData,
            isPersonalDetailsFieldErrors: payload,
        },
    };
}
function setShippingDetailsContinue(state, { payload }) {
    return {
        ...state,
        isShippingDetailsContinue: payload,
    };
}
function setShippingDetailsData(state, { payload }) {
    return {
        ...state,
        shippingDetailsData: {
            ...state.shippingDetailsData,
            data: payload,
        },
    };
}
function setShippingDetailsFieldsErrors(state, { payload }) {
    return {
        ...state,
        shippingDetailsData: {
            ...state.shippingDetailsData,
            isShippingDetailsFieldErrors: payload,
        },
    };
}
function setLoqateKey(state, { payload }) {
    return {
        ...state,
        loqateKey: payload,
    };
}
function setGoogleKey(state, { payload }) {
    return {
        ...state,
        googleKey: payload,
    };
}
function setDealerList(state, { payload }) {
    return {
        ...state,
        dealerData: {
            ...state.dealerData,
            dealerList: payload,
        },
    };
}
function setCreatedYamahaAccount(state, { payload }) {
    return {
        ...state,
        isCreateAcc: payload,
    };
}
function setBillingAddresFieldsErrors(state, { payload }) {
    return {
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            isBillingAddressFieldErrors: payload,
        },
    };
}
function getConvertCartRequestReducer(state) {
    return {
        ...state,
        orderReviewData: {
            ...state.orderReviewData,
            orderId: '',
            status: '',
            isLoading: true,
            errorResponse: {},
        },
    };
}
function getConvertCartSuccessReducer(state, { payload: { data: { orderId, status, errorResponse, santanderPaymentLink, orderNumber }, }, }) {
    return {
        ...state,
        orderReviewData: {
            ...state.orderReviewData,
            status,
            isLoading: false,
            santanderPaymentLink,
            orderNumber,
            orderId: orderId || '',
            errorResponse,
        },
    };
}
function getConvertCartFailureReducer(state) {
    return {
        ...state,
        orderReviewData: {
            ...state.orderReviewData,
            orderId: '',
            status: '',
            isLoading: false,
            errorResponse: {},
        },
    };
}
function setSameAsShippingAddress(state, { payload }) {
    return {
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            sameAsShippingAddress: payload,
        },
    };
}
function setOrderReviewModel(state, { payload }) {
    return {
        ...state,
        orderReviewModel: payload,
    };
}
function setBillingAddressData(state, { payload }) {
    return {
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            data: payload,
        },
    };
}
function setShippingDetailsEmailError(state, { payload }) {
    return {
        ...state,
        shippingDetailsEmailError: payload,
    };
}
function setBillingOption(state, { payload }) {
    return {
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            billingOption: payload,
        },
    };
}
function setPayment(state, { payload }) {
    return {
        ...state,
        payment: {
            ...state.payment,
            session: payload.data,
            config: payload.config,
        },
    };
}
function setDealersTools(state, { payload }) {
    return {
        ...state,
        dealersTools: payload,
    };
}
function setPaymentProvider(state, { payload }) {
    return {
        ...state,
        paymentProvider: payload,
    };
}
function setPayeverConfigModel(state, { payload }) {
    return {
        ...state,
        payeverConfigModel: payload,
    };
}
function setOrderReviewStatus(state, { payload }) {
    return {
        ...state,
        orderReviewData: {
            ...state.orderReviewData,
            status: payload,
        },
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.checkoutLabels, setCheckoutLabels)
        .addCase(actions.asGuestEmail, setAsGuestEmail)
        .addCase(actions.currentStepNumber, setCurrentStepNumber)
        .addCase(actions.currentFormName, setCurrentFormName)
        .addCase(actions.activePreferDealerId, (state, { payload: { vicinityId } }) => ({
        ...state,
        dealerData: {
            ...state.dealerData,
            activePreferDealerId: vicinityId,
        },
    }))
        .addCase(actions.paymentProvider, setPaymentProvider)
        .addCase(actions.payeverConfigModel, setPayeverConfigModel)
        .addCase(actions.salutations, setSalutations)
        .addCase(actions.personalDetailsData, setPersonalDetailsData)
        .addCase(actions.personalDetailsErrors, setPersonalDetailsErrorsFieldError)
        .addCase(actions.shippingDetailsContinue, setShippingDetailsContinue)
        .addCase(actions.shippingDetailsData, setShippingDetailsData)
        .addCase(actions.isPickUpAtDealerDisabled, setPickUpAtDealerDisabled)
        .addCase(actions.dealerList, setDealerList)
        .addCase(actions.shippingDetailsFieldsErrors, setShippingDetailsFieldsErrors)
        .addCase(actions.loqateKey, setLoqateKey)
        .addCase(actions.googleKey, setGoogleKey)
        .addCase(actions.createdYamahaAccount, setCreatedYamahaAccount)
        .addCase(actions.billingAddressFieldErrors, setBillingAddresFieldsErrors)
        .addCase(actions.convertCartRequest, getConvertCartRequestReducer)
        .addCase(actions.convertCartSuccess, getConvertCartSuccessReducer)
        .addCase(actions.convertCartFailure, getConvertCartFailureReducer)
        .addCase(actions.orderReviewModel, setOrderReviewModel)
        .addCase(actions.billingAddressData, setBillingAddressData)
        .addCase(actions.sameAsShippingAddress, setSameAsShippingAddress)
        .addCase(actions.shippingDetailsEmailError, setShippingDetailsEmailError)
        .addCase(actions.setPayment, setPayment)
        .addCase(actions.billingOption, setBillingOption)
        .addCase(actions.dealersTools, setDealersTools)
        .addCase(actions.orderReviewStatus, setOrderReviewStatus)
        .addCase(actions.setIsBillingAndDealersSwapped, swapBillingAndDealers)
        .addCase(actions.setIsPostalCodeInExclusionList, setPostalCodeInExclusionList)
        .addCase(actions.setAddressConfig, (state, action) => ({
        ...state,
        addressConfig: action.payload,
    }))
        .addCase(actions.setPaymentSuccess, (state) => ({
        ...state,
        payment: {
            ...state.payment,
            error: undefined,
        },
    }))
        .addCase(actions.setPaymentErrors, (state, action) => ({
        ...state,
        payment: {
            ...state.payment,
            error: action?.payload,
        },
    }))
        .addCase(actions.setBillingCountries, (state, action) => ({
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            billingCountries: action.payload,
        },
    }))
        .addCase(actions.setBillingStates, (state, action) => ({
        ...state,
        billingAddressData: {
            ...state.billingAddressData,
            billingStates: action.payload,
        },
    }))
        .addCase(actions.setCheckoutLogin, (state, action) => ({
        ...state,
        isCheckoutLogin: action.payload,
    }));
});
